import { createApi } from '@reduxjs/toolkit/query/react'

import { baseQueryWithReAuth } from './base-query'
import type { OkResponse } from './types/common'
import type {
	ListNotificationsParams,
	ListNotificationsResponse,
	UnreadCountResponse,
} from './types/notification'

export const notificationsApi = createApi({
	reducerPath: 'notificationsApi',
	baseQuery: baseQueryWithReAuth,
	tagTypes: ['Notification', 'UnreadCount'],
	endpoints: (builder) => ({
		listNotifications: builder.query<ListNotificationsResponse, ListNotificationsParams | void>({
			query: (params) => ({ url: '/notifications', params: params ?? {} }),
			providesTags: ['Notification'],
		}),

		getUnreadCount: builder.query<UnreadCountResponse, void>({
			query: () => '/notifications/unread-count',
			providesTags: ['UnreadCount'],
		}),

		markAsRead: builder.mutation<OkResponse, string>({
			query: (id) => ({ url: `/notifications/${id}/read`, method: 'PATCH' }),
			invalidatesTags: ['Notification', 'UnreadCount'],
		}),

		markAllAsRead: builder.mutation<OkResponse, void>({
			query: () => ({ url: '/notifications/mark-all-read', method: 'POST' }),
			invalidatesTags: ['Notification', 'UnreadCount'],
		}),

		deleteNotification: builder.mutation<OkResponse, string>({
			query: (id) => ({ url: `/notifications/${id}`, method: 'DELETE' }),
			invalidatesTags: ['Notification', 'UnreadCount'],
		}),
	}),
})

export const {
	useListNotificationsQuery,
	useGetUnreadCountQuery,
	useMarkAsReadMutation,
	useMarkAllAsReadMutation,
	useDeleteNotificationMutation,
} = notificationsApi
